const slide = {
  right: {
    initial: {
      x: '100%'
    },
    animate: {
      x: 0,
      transitionEnd: {
        x: 0
      }
    },
    exit: {
      x: '100%'
    }
  },
  left: {
    initial: {
      x: '-100%'
    },
    animate: {
      x: 0,
      transitionEnd: {
        x: 0
      }
    },
    exit: {
      x: '-100%'
    }
  },
  top: {
    initial: {
      y: '-100%'
    },
    animate: {
      y: 0,
      transitionEnd: {
        y: 0
      }
    },
    exit: {
      y: '-100%'
    }
  },
  bottom: {
    initial: {
      y: '100%'
    },
    animate: {
      y: 0,
      transitionEnd: {
        y: 0
      }
    },
    exit: {
      y: '100%'
    }
  }
};

export { slide };
//# sourceMappingURL=slide.js.map
